export const findSearchValue = (key: string): string | undefined => {
  const result = window.location.search
    .split('&')
    .find((x) => x.includes(`${key}=`))
    ?.split('=')[1];

  return result;
};

// im using this for cases when value contains "="
export const findSearchValueFull = (key: string): string | undefined => {
  const search = window.location.search.startsWith('?') ? window.location.search.slice(1) : window.location.search;

  const pair = search.split('&').find((x) => x.startsWith(`${key}=`));

  if (!pair) return undefined;

  const value = pair.slice(key.length + 1); // everything after the first '='

  // optional: decode if the value is URL-encoded
  try {
    return decodeURIComponent(value.replace(/\+/g, ' '));
  } catch {
    return value;
  }
};
